import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CreditorsServiceService } from './creditors-service.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import { Router } from '@angular/router';
import { FinancialpositionService } from '../../financialposition/financialposition.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-creditors',
  templateUrl: './creditors.component.html',
  styleUrls: ['./creditors.component.scss']
})
export class CreditorsComponent implements OnInit {
  credformoneyear: FormGroup;
  APPeriodId: any; isJump: any;
  credid: any;
  mcredid: any;
  balancesheetvalues: any
  Creditorsoneyear: any;
  CreditorsoneyearLy: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, private credservice: CreditorsServiceService, public commonService: CommonService, private router: Router, public balanceSheetService: FinancialpositionService, public sidenav: SideNavService) { }
  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.commonService.getNotesData();

    this.getBalanceSheetData(this.APPeriodId);
    this.createCreditorsForm_WithinOneYear();
     this.getonecred(this.APPeriodId)
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyearcreditor()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
      this.clearfield();
    if (localStorage.getItem("SubmitStatus") == "true")
      this.credformoneyear.disable()
    }
 
  createCreditorsForm_WithinOneYear() {
    this.credformoneyear = this.formbuilder.group({
      CreditorsWithInOneYearId: new FormControl(),
      APPeriodId: new FormControl(),
      BankBorrowingsOverdrafts: new FormControl(),
      BankBorrowingsOverdrafts_LY: new FormControl(),
      FinanceLeaseLiabilitiesPresentValueTotal: new FormControl(),
      FinanceLeaseLiabilitiesPresentValueTotal_LY: new FormControl(),
      AndicaTradeCreditorsTradePayables: new FormControl(),
      AndicaTradeCreditorsTradePayables_LY: new FormControl(),
      OtherTaxationSocialSecurityPayable: new FormControl(),
      OtherTaxationSocialSecurityPayable_LY: new FormControl(),
      AccruedLiabilitiesDeferredIncome: new FormControl(),
      AccruedLiabilitiesDeferredIncome_LY: new FormControl(),
      OtherCreditors: new FormControl(),
      OtherCreditors_LY: new FormControl(),
      IntangibleAssets_LY: new FormControl(),
      CreditorsDueWithinOneYear: new FormControl(),
      CreditorsDueWithinOneYear_LY: new FormControl(),
      Security: new FormControl(),
      DescriptionMaterialOperatingLeasingArrangements: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }
  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.credformoneyear.reset()
      }
    })
  }
  Insertonecred() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.credformoneyear.controls['APPeriodId'].setValue(this.APPeriodId)
    this.credformoneyear.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.credformoneyear.getRawValue();
    if (this.credid) {
      formdata.CreditorsMoreThanOneYearId = this.credid
      //this.credformoneyear.controls['CreditorsMoreThanOneYearId'].setValue(this.credid)
    }
    this.credservice.insertcredators(formdata).subscribe((data) => {
      
    })
  }
  getonecred(APPeriodId) {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.credservice.getcredators(this.APPeriodId).subscribe((data:any) => {
      if (data) {
        this.credformoneyear.patchValue(data)
        this.credid = data.CreditorsWithInOneYearId
        this.credformoneyear.controls['CreditorsDueWithinOneYear'].disable();
        this.credformoneyear.controls['CreditorsDueWithinOneYear_LY'].disable();
      }
    })
  }
  getlastyearcreditor() {
    this.credservice.getlastcredators(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  save() {
    debugger
    if (this.Validations()) {
      this.Insertonecred();
      this.credformoneyear.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Creditors - within one year", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'creditors-withinoneyear') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
   
  }

  back() {
    debugger
    this.credformoneyear.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Creditors - within one year", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }


  calculationsforOneYear() {
    debugger
    const total= parseFloat(((this.credformoneyear.controls['BankBorrowingsOverdrafts'].value == "" || this.credformoneyear.controls['BankBorrowingsOverdrafts'].value == null) ? 0 : this.credformoneyear.controls['BankBorrowingsOverdrafts'].value))
      + parseFloat(((this.credformoneyear.controls['FinanceLeaseLiabilitiesPresentValueTotal'].value == "" || this.credformoneyear.controls['FinanceLeaseLiabilitiesPresentValueTotal'].value == null) ? 0 : this.credformoneyear.controls['FinanceLeaseLiabilitiesPresentValueTotal'].value))
      + parseFloat(((this.credformoneyear.controls['AndicaTradeCreditorsTradePayables'].value == "" || this.credformoneyear.controls['AndicaTradeCreditorsTradePayables'].value == null) ? 0 : this.credformoneyear.controls['AndicaTradeCreditorsTradePayables'].value))
       + parseFloat(((this.credformoneyear.controls['OtherTaxationSocialSecurityPayable'].value == "" || this.credformoneyear.controls['OtherTaxationSocialSecurityPayable'].value == null) ? 0 : this.credformoneyear.controls['OtherTaxationSocialSecurityPayable'].value))
       + parseFloat(((this.credformoneyear.controls['AccruedLiabilitiesDeferredIncome'].value == "" || this.credformoneyear.controls['AccruedLiabilitiesDeferredIncome'].value == null) ? 0 : this.credformoneyear.controls['AccruedLiabilitiesDeferredIncome'].value))
       + parseFloat(((this.credformoneyear.controls['OtherCreditors'].value == "" || this.credformoneyear.controls['OtherCreditors'].value == null) ? 0 : this.credformoneyear.controls['OtherCreditors'].value))
    this.credformoneyear.controls["CreditorsDueWithinOneYear"].setValue(total);
  }

  lastyearcalculations() {
    const total = parseFloat((this.credformoneyear.controls['BankBorrowingsOverdrafts_LY'].value == "" || this.credformoneyear.controls['BankBorrowingsOverdrafts_LY'].value == null) ? 0 : this.credformoneyear.controls['BankBorrowingsOverdrafts_LY'].value)
      +
      parseFloat((this.credformoneyear.controls['FinanceLeaseLiabilitiesPresentValueTotal_LY'].value == "" || this.credformoneyear.controls['FinanceLeaseLiabilitiesPresentValueTotal_LY'].value == null) ? 0 : this.credformoneyear.controls['FinanceLeaseLiabilitiesPresentValueTotal_LY'].value)
      + parseFloat((this.credformoneyear.controls['AndicaTradeCreditorsTradePayables_LY'].value == "" || this.credformoneyear.controls['AndicaTradeCreditorsTradePayables_LY'].value == null) ? 0 : this.credformoneyear.controls['AndicaTradeCreditorsTradePayables_LY'].value)
      + parseFloat((this.credformoneyear.controls['OtherTaxationSocialSecurityPayable_LY'].value == "" || this.credformoneyear.controls['OtherTaxationSocialSecurityPayable_LY'].value == null) ? 0 : this.credformoneyear.controls['OtherTaxationSocialSecurityPayable_LY'].value)
      + parseFloat((this.credformoneyear.controls['AccruedLiabilitiesDeferredIncome_LY'].value == "" || this.credformoneyear.controls['AccruedLiabilitiesDeferredIncome_LY'].value == null) ? 0 : this.credformoneyear.controls['AccruedLiabilitiesDeferredIncome_LY'].value)
      + parseFloat((this.credformoneyear.controls['OtherCreditors_LY'].value == "" || this.credformoneyear.controls['OtherCreditors_LY'].value == null) ? 0 : this.credformoneyear.controls['OtherCreditors_LY'].value)
    this.credformoneyear.controls['CreditorsDueWithinOneYear_LY'].setValue(total);
  }



  getBalanceSheetData(apPeriodId) {
    debugger
    //if (this.commonService.AccountTemplateId == 11) {
    //  this.balanceSheetService.getBalanceSheetFRS101(apPeriodId).subscribe((data: any) => {
    //    this.balancesheetvalues = data;
    //    this.Creditorsoneyear = Math.abs(data.TradeAndOtherPayables);
    //    this.CreditorsoneyearLy = Math.abs(data.TradeAndOtherPayables_LY);
    //  })
    //}
 /*   else {*/
      this.balanceSheetService.getBalanceSheet(apPeriodId).subscribe((data: any) => {
        this.balancesheetvalues = data;
        this.Creditorsoneyear = Math.abs(data.CreditorsAmountsFallingDueWithinOneYear);
        this.CreditorsoneyearLy = Math.abs(data.CreditorsAmountsFallingDueWithinOneYear_LY);
      })
    //}
  }

  Validations() {
    debugger
    if (this.commonService.showControl == true) {
    if (((this.credformoneyear.controls['CreditorsDueWithinOneYear'].value == "" || this.credformoneyear.controls['CreditorsDueWithinOneYear'].value == null) ? 0 : this.credformoneyear.controls['CreditorsDueWithinOneYear'].value) != this.Creditorsoneyear) {
      Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Creditors-amounts falling due within one year value in the balance sheet for the year " + this.commonService.StartYear + ".", 'warning')
      return false;
    }
    else if (((this.credformoneyear.controls['CreditorsDueWithinOneYear_LY'].value == "" || this.credformoneyear.controls['CreditorsDueWithinOneYear_LY'].value == null) ? 0 : this.credformoneyear.controls['CreditorsDueWithinOneYear_LY'].value) != this.CreditorsoneyearLy) {
      Swal.fire('Andica Accounts Production', "Total value for the yearly " + this.commonService.LastYear + " must tally with the Creditors-amounts falling due after more than one year value in the balance sheet for the year " + this.commonService.LastYear + ".", 'warning')
      return false;
    }
    else {
      return true;
    }

    }
    else {
      if (((this.credformoneyear.controls['CreditorsDueWithinOneYear'].value == "" || this.credformoneyear.controls['CreditorsDueWithinOneYear'].value == null) ? 0 : this.credformoneyear.controls['CreditorsDueWithinOneYear'].value) != this.Creditorsoneyear) {
        Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Creditors-amounts falling due within one year value in the balance sheet for the year " + this.commonService.StartYear + ".", 'warning')
        return false;
      }
      else {
        return true;
      }
    }

  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.credformoneyear.dirty ) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br><span>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        this.NormalRoutng = true;
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}

